<ng-template #bar>
   <mat-progress-bar></mat-progress-bar>
</ng-template>

<ng-template #spinner>
   <mat-spinner diameter="30"></mat-spinner>
</ng-template>

<ng-template #delete_confirm>
   <div class="buttons common-uppercase common-jcfe">
      Are you sure?
      <button mat-raised-button color="warn" (click)="delete()" class="common-ml1em">
         DELETE
      </button>
      <button mat-button (click)="deleting = false">CANCEL</button>
   </div>
</ng-template>


<div class="business">
   <ng-container *ngIf="!loading else spinner">
      <ng-container *ngIf="!saving else spinner">
         <ng-container *ngIf="!deleting else delete_confirm">
            <div class="buttons">
               <button mat-stroked-button routerLink="/addressbook" *ngIf="breakpoints.small">
                  <mat-icon>chevron_left</mat-icon> CANCEL
               </button>

               <button mat-raised-button color="primary" [disabled]="businessForm.invalid" (click)="save()">
                  <mat-icon>save</mat-icon> SAVE
               </button>

               <ng-container *ngIf="id">
                  <ng-container *ngIf="!breakpoints.xsmall else xsmallButtons">
                     <button mat-raised-button color="accent" routerLink="/addressbook/duplicate/{{id}}">
                        <mat-icon class="common-duplicateicon">filter_none</mat-icon> DUPLICATE
                     </button>

                     <button mat-raised-button color="warn" (click)="deleting = true" class="common-mlauto">
                        <mat-icon>clear</mat-icon> DELETE
                     </button>
                  </ng-container>
               </ng-container>

               <mat-button-toggle-group [value]="filter" style="margin-right: 0; margin-left: auto;" (change)="filterChange($event.value)">
                  <mat-button-toggle style="width: inherit;" [value]="'all'">
                     <mat-icon [svgIcon]="'shipments'"></mat-icon>
                        ALL
                  </mat-button-toggle>
                  <mat-button-toggle style="width: inherit;" [value]="'account'">
                     <mat-icon>supervisor_account</mat-icon>
                     ACCOUNT
                  </mat-button-toggle>
                  <mat-button-toggle style="width: inherit;" [value]="'personal'">
                     <mat-icon>person</mat-icon>
                     PERSONAL
                  </mat-button-toggle>
               </mat-button-toggle-group>
            </div>

            <ng-template #xsmallButtons>
               <button mat-icon-button color="primary" [matMenuTriggerFor]="xsmallMenu" class="common-mlauto">
                  <mat-icon>more_vert</mat-icon>
               </button>

               <mat-menu #xsmallMenu>
                  <button mat-menu-item color="primary" *ngIf="id" routerLink="/addressbook/duplicate/{{id}}">
                     <mat-icon class="common-duplicateicon">filter_none</mat-icon> DUPLICATE
                  </button>
                  <button mat-menu-item color="warn" *ngIf="id" (click)="deleting = true">
                     <mat-icon color="warn">clear</mat-icon> DELETE
                  </button>
               </mat-menu>
            </ng-template>
         </ng-container>
      </ng-container>

      <form [formGroup]="businessForm">
         <div class="business-form">
            <mat-form-field #type_field>
               <mat-label>Address Book Type</mat-label>
               <mat-select formControlName="type" required>
                  <mat-option [value]="'account'">Account</mat-option>
                  <mat-option [value]="'personal'">Personal</mat-option>
               </mat-select>
            </mat-form-field>

            <mat-form-field #name_field>
               <mat-label>Location Name</mat-label>
               <input matInput #name [required]="required?.name" [maxlength]="lengths?.name" required [maxlength]="lengths?.name" formControlName="name">
               <mat-error libInputErrors [control]="businessForm.get('name')"></mat-error>
               <mat-hint align="end" *ngIf="focused( name_field ) && name?.value.length as l">{{l || 0}} / {{lengths?.name}}</mat-hint>
            </mat-form-field>

            <ng-container *ngIf="countries.countries | async else spinner">
               <mat-form-field #country_field>
                  <mat-label>Country</mat-label>
                  <mat-select formControlName="country" [required]="required?.country">
                     <mat-option *ngFor="let country of countries.countries | async" [value]="country.code">{{country.country}}</mat-option>
                  </mat-select>
               </mat-form-field>

               <mat-form-field #address1_field>
                  <mat-label>Address Line 1</mat-label>
                  <input matInput #address1 [required]="required?.address1" [maxlength]="lengths?.address1" formControlName="address1">
                  <mat-error libInputErrors [control]="businessForm.get('address1')"></mat-error>
                  <mat-hint align="end" *ngIf="focused( address1_field ) && address1?.value.length as l">{{l || 0}} / {{lengths?.address1}}</mat-hint>
               </mat-form-field>

               <mat-form-field #address2_field>
                  <mat-label>Address Line 2</mat-label>
                  <input matInput #address2 [required]="required?.address2" [maxlength]="lengths?.address2" formControlName="address2">
                  <mat-error libInputErrors [control]="businessForm.get('address2')"></mat-error>
                  <mat-hint align="end" *ngIf="focused( address2_field ) && address2?.value.length as l">{{l || 0}} / {{lengths?.address2}}</mat-hint>
               </mat-form-field>

               <mat-form-field #address3_field>
                  <mat-label>Address Line 3</mat-label>
                  <input matInput #address3 [required]="required?.address3" [maxlength]="lengths?.address3" formControlName="address3">
                  <mat-error libInputErrors [control]="businessForm.get('address3')"></mat-error>
                  <mat-hint align="end" *ngIf="focused( address3_field ) && address3?.value.length as l">{{l || 0}} / {{lengths?.address3}}</mat-hint>
               </mat-form-field>

               <div class="business-form-line">
                  <mat-form-field #city_field>
                     <mat-label>City</mat-label>
                     <input matInput #city [required]="required?.city" [maxlength]="lengths?.city" formControlName="city">
                     <mat-error libInputErrors [control]="businessForm.get('city')"></mat-error>
                     <mat-hint align="end" *ngIf="focused( city_field ) && city?.value.length as l">{{l || 0}} / {{lengths?.city}}</mat-hint>
                  </mat-form-field>

                  <mat-form-field #state_field *ngIf="(countries.country( country.value ) | async)?.regions; else textRegion">
                     <mat-label>Region</mat-label>
                     <mat-select formControlName="state" [required]="required?.state">
                        <mat-option *ngFor="let state of (countries.country( country.value ) | async)?.regions" [value]="state.code">
                           {{ state.region }}
                        </mat-option>
                     </mat-select>
                     <mat-error libInputErrors [control]="businessForm.get('state')"></mat-error>
                  </mat-form-field>

                  <ng-template #textRegion>
                     <mat-form-field #state_field>
                        <mat-label>Region</mat-label>
                        <input matInput #state formControlName="state" [required]="required?.state" />
                        <mat-error libInputErrors [control]="businessForm.get('state')"></mat-error>
                        <mat-hint align="end" *ngIf="focused( state_field ) && state?.value.length as l">{{l || 0}} / {{lengths?.state}}</mat-hint>
                     </mat-form-field>
                  </ng-template>

                  <mat-form-field #postalcode_field>
                     <mat-label>Postal Code</mat-label>
                     <input #postalcode matInput [placeholder]="(countries.country( country.value ) | async)?.postalDetails?.postalExample" [required]="required?.postalcode" [maxlength]="lengths?.postalcode" formControlName="postalcode">
                     <mat-error libInputErrors [control]="businessForm.get('postalcode')"></mat-error>
                     <mat-hint align="end" *ngIf="focused( postalcode_field ) && postalcode?.value.length as l">
                        {{l || 0}} / {{lengths?.postalcode}}
                     </mat-hint>
                  </mat-form-field>
               </div>

               <div class="business-form-line">
                  <mat-form-field #phone_field>
                     <mat-label>Phone Number</mat-label>
                     <input matInput #phone formControlName="phone" [required]="required?.phone" [maxlength]="lengths?.phone">
                     <mat-error libInputErrors [control]="businessForm.get('phone')"></mat-error>
                     <mat-hint align="end" *ngIf="focused( phone_field ) && phone?.value.length as l">{{l || 0}} / {{lengths?.phone}}</mat-hint>
                  </mat-form-field>

                  <mat-form-field #fax_field>
                     <mat-label>Fax Number</mat-label>
                     <input matInput #fax formControlName="fax" [required]="required?.fax" [maxlength]="lengths?.fax">
                     <mat-error libInputErrors [control]="businessForm.get('fax')"></mat-error>
                     <mat-hint align="end" *ngIf="focused( fax_field ) && fax?.value.length as l">{{l || 0}} / {{lengths?.fax}}</mat-hint>
                  </mat-form-field>
               </div>
            </ng-container>
         </div>

         <lib-contacts [contacts]="businessForm.get( 'contacts' )"></lib-contacts>
      </form>
   </ng-container>
</div>
